import React, { useState, useMemo } from "react";
import { Search, X } from "lucide-react";
import { CELEBRITIES, CATEGORIES } from "../data/celebrities";

export const CelebritySearch = ({ onPick, excludeIds = [], testId = "celeb-search" }) => {
  const [query, setQuery] = useState("");
  const [cat, setCat] = useState("All");

  const filtered = useMemo(() => {
    return CELEBRITIES.filter(
      (c) =>
        !excludeIds.includes(c.id) &&
        (cat === "All" || c.category === cat) &&
        (query === "" || c.name.toLowerCase().includes(query.toLowerCase()))
    );
  }, [query, cat, excludeIds]);

  return (
    <div data-testid={testId} className="rounded-2xl border border-white/10 bg-[#16141D] p-3">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#FDFBF7]/50" />
        <input
          data-testid={`${testId}-input`}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search a celebrity"
          className="w-full pl-9 pr-9 py-2.5 rounded-full bg-black/30 border border-white/10 text-[#FDFBF7] text-sm placeholder:text-[#FDFBF7]/40 focus:outline-none focus:border-[#00E5FF]"
        />
        {query && (
          <button
            data-testid={`${testId}-clear`}
            onClick={() => setQuery("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[#FDFBF7]/50 hover:text-[#FF107A]"
          >
            <X size={16} />
          </button>
        )}
      </div>
      <div className="flex gap-1.5 mt-3 overflow-x-auto no-scrollbar pb-1">
        {["All", ...CATEGORIES].map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.toLowerCase().replace(/\s|&/g, "-")}`}
            onClick={() => setCat(c)}
            className={`shrink-0 px-3 py-1 rounded-full text-xs font-semibold tracking-wide uppercase border transition-all ${
              cat === c ? "bg-[#A855F7] border-[#A855F7] text-white" : "bg-transparent border-white/15 text-[#FDFBF7]/70 hover:border-[#A855F7]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>
      <div className="mt-3 max-h-56 overflow-y-auto space-y-1.5">
        {filtered.length === 0 && (
          <p className="text-center py-6 text-sm text-[#FDFBF7]/40">No matches. Try another search.</p>
        )}
        {filtered.map((c) => (
          <button
            key={c.id}
            data-testid={`pick-${c.id}`}
            onClick={() => onPick(c)}
            className="w-full flex items-center gap-3 p-2 rounded-lg bg-black/20 hover:bg-[#FF107A]/10 border border-transparent hover:border-[#FF107A]/40 transition-all text-left"
          >
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center font-display text-lg shrink-0"
              style={{
                background: `linear-gradient(135deg, ${c.palette[0]}, ${c.palette[1]})`,
                color: c.palette[2],
              }}
            >
              {c.name
                .split(" ")
                .map((p) => p[0])
                .join("")
                .slice(0, 2)}
            </div>
            <div className="min-w-0">
              <div className="text-sm text-[#FDFBF7] font-semibold truncate">{c.name}</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-[#FDFBF7]/50">
                {c.category} · {c.era}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
